<template>
    <div class="LoginPage">



        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <login @login_success="loginSuccess"></login>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <register></register>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Login from "./login/login";
    import Register from "./register/register";

    export default {
        props: {
        },
        components: {
            Register,
            Login,
        },
        methods: {
            loginSuccess: function(evt) {
                this.$emit('login_success',evt);
            }
        }
    };
</script>
